/** Auto-refresh interval for platform usage monitoring dashboard. */
export const PLATFORM_USAGE_REFETCH_INTERVAL_MS = 30_000;

export const PLATFORM_USAGE_RECENT_LIMIT = 50;

export const PLATFORM_USAGE_SUMMARY_MINUTES = 30;

export const PLATFORM_USAGE_QUERY_KEYS = {
  live: ['platform-usage', 'live'] as const,
  recent: (limit: number) => ['platform-usage', 'recent', limit] as const,
  summary: (minutes: number) => ['platform-usage', 'summary', minutes] as const,
};
